module.exports = {
	"notification.message": "Wix.com bruger cookies, så du får den bedst mulige oplevelse.",
	"notification.got.it": "Jeg har forstået det",
	"notification.more.info": "Læs mere",
	"notification.got.it.arrow": "arrow icon"
};


//////////////////
// WEBPACK FOOTER
// ./assets/locale/messages_da.json
// module id = 37
// module chunks = 0